<div class="row">
    <div class="col-12 caption mb-3">
        <span class="caption-subject">
            <strong>Áp dụng các lệnh từ ngày
                <span class="required">*</span>
            </strong>
        </span>
    </div>
    <div class="col-12 mb-3">
        <input-datepicker-and-time [(data)]="startDate" ></input-datepicker-and-time>
    </div>

    <div class="col-12 mb-3">
        <app-edit-fee [isValidated]="isSaved" [isNoUnitConfigByMoney]="true"
            [feeList]="fees" [typeCode]="'SELL'" [isUnitConfig]="true" [unitValue]="'MONTH'"
            [relationalOperators]="relationalOperators">
        </app-edit-fee>
    </div>

    <div class="col-12 mb-3">
        <div class="d-flex justify-content-end">
            <button  class="btn btn-ok btn--default" style="margin-right: 20px;" (click)="getBefore()"><i nz-icon
                nzType="sync" nzTheme="outline"></i><span
                style="margin-left: 5px;">Phí hiện có</span>
            </button>
            <button  class="btn btn-ok btn-delete_fee" style="margin-right: 20px;" (click)="delete()"><i nz-icon
                nzType="delete" nzTheme="outline"></i><span
                style="margin-left: 5px;">Xóa</span>
            </button>
            <button  class="btn btn-ok btn--blue" (click)="save()"><i nz-icon
                nzType="save" nzTheme="outline"></i><span
                style="margin-left: 5px;">Lưu lại</span>
            </button>
        </div>
    </div>
</div>